// CVG3-DISC (CVG2-WON carry-over, 2026-07-11) — SO terms chips for the web
// SO detail page. Exact mirror of the mobile helper `soTermChips` in
// mobile/apps/aura_sales/lib/features/proposals/data/convert_so_form.dart:
// a chip renders ONLY for a non-null term; legacy pre-CVG2 orders (all three
// null) produce an empty list → the caller omits the whole block.
export interface SoTermFields {
  installationIncluded?: boolean | null;
  shippingIncluded?: boolean | null;
  liftingIncluded?: boolean | null;
}

export interface SoTermChip {
  label: string;
  value: boolean;
}

export function soTermChips(so: SoTermFields): SoTermChip[] {
  const chips: SoTermChip[] = [];
  if (so.installationIncluded != null) chips.push({ label: 'Installation', value: so.installationIncluded });
  if (so.shippingIncluded != null) chips.push({ label: 'Shipping', value: so.shippingIncluded });
  if (so.liftingIncluded != null) chips.push({ label: 'Lifting', value: so.liftingIncluded });
  return chips;
}

// T-045-W — same three close-won term fields, one label map so the conflict
// panel names a term the same way the chips above it do.
export type SoTermField = 'installationIncluded' | 'shippingIncluded' | 'liftingIncluded';

export const SO_TERM_LABELS: Record<SoTermField, string> = {
  installationIncluded: 'Installation',
  shippingIncluded: 'Shipping',
  liftingIncluded: 'Lifting',
};

// Shape of one entry in `config.termConflicts`, surfaced read-only on
// GET /:id (backend/src/modules/sales/sales-orders.routes.ts, T-045-B B2).
// `answered` is the rep's value (currently on the order — direction A, her
// answer stays the default until resolved); `derived` is what the proposal's
// charges implied. 🔒 This is the server's computed record — nothing here
// re-derives a conflict from the order's own fields.
export interface SoTermConflict {
  field: SoTermField;
  answered: boolean;
  derived: boolean;
}
